import PropTypes from 'prop-types';
import { useEffect } from 'react';

import history from 'util/History';

import Routes from './common/Routes.js';

// https://stackoverflow.com/questions/52912238/render-methods-should-be-a-pure-function-of-props-and-state
const O365InputConfiguration = ({ url }) => {
  useEffect(() => {
    history.push(url);
  }, []);

  return null;
};

O365InputConfiguration.propTypes = {
  url: PropTypes.string,
};

O365InputConfiguration.defaultProps = {
  url: Routes.INTEGRATIONS.O365.ACTIVITYAPI.index,
};

export default O365InputConfiguration;
